export const scrollToTop = (): ReturnType<typeof setTimeout> => {
    return setTimeout(() => {
        window.scrollTo(0, 0)
    }, 100)
}
